
(function () {
  if (window.__horecaInit) return;
  window.__horecaInit = true;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    var body = document.body;

    /* ---- Mobile drawer ---- */
    var mbtn = document.getElementById('mbtn'),
        drawer = document.getElementById('drawer'),
        ovl = document.getElementById('ovl'),
        cbtn = document.getElementById('cbtn');
    function openMenu() { if (drawer) { drawer.classList.add('open'); ovl && ovl.classList.add('open'); body.style.overflow = 'hidden'; } }
    function closeMenu() { if (drawer) { drawer.classList.remove('open'); ovl && ovl.classList.remove('open'); body.style.overflow = ''; } }
    if (mbtn) mbtn.addEventListener('click', openMenu);
    if (cbtn) cbtn.addEventListener('click', closeMenu);
    if (ovl) ovl.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

    /* ---- Wishlist toggle (visual only; wire to an app if needed) ---- */
    document.addEventListener('click', function (e) {
      var w = e.target.closest('[data-wish]');
      if (w) { e.preventDefault(); e.stopPropagation(); w.classList.toggle('on'); w.style.color = w.classList.contains('on') ? '#b23b2e' : ''; }
    });

    /* ---- Product-slider arrows (data-ps = track id, data-dir = prev|next) ---- */
    document.querySelectorAll('[data-ps]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = document.getElementById(b.getAttribute('data-ps')); if (!t) return;
        var card = t.querySelector('.pcard');
        var g = parseInt(getComputedStyle(t).columnGap) || 18;
        var step = (card ? card.getBoundingClientRect().width : 260) + g;
        t.scrollBy({ left: (b.getAttribute('data-dir') === 'next' ? 1 : -1) * step * 2, behavior: 'smooth' });
      });
    });

    /* ---- Review rail arrows ---- */
    var rvr = document.getElementById('rvrail');
    document.querySelectorAll('[data-rv]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!rvr) return;
        var card = rvr.querySelector('.rvcard');
        var step = card ? card.offsetWidth + 16 : 300;
        rvr.scrollBy({ left: (b.getAttribute('data-rv') === 'next' ? 1 : -1) * step, behavior: 'smooth' });
      });
    });

    /* ---- Reveal on scroll ---- */
    var rm = window.matchMedia('(prefers-reduced-motion:reduce)').matches, io;
    if (!rm && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { threshold: .08, rootMargin: '0px 0px -30px' });
    }
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (rm || !io) { els.forEach(function (e) { e.classList.add('in'); }); }
    else { els.forEach(function (e) { io.observe(e); }); }
  }
})();


  (function () {
    function initHoverCat() {
      var trigger = document.querySelector('.megamenu-content .vega-menu-area > a.browse-cat');
      if (!trigger) return;
      var isDesktop = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)').matches;
      if (isDesktop) {
        // detach Bootstrap's click toggle so hover is the only trigger
        trigger.removeAttribute('data-bs-toggle');
        trigger.setAttribute('data-hover-only', 'true');
        trigger.addEventListener('click', function (e) { e.preventDefault(); });
      } else {
        if (trigger.getAttribute('data-hover-only')) {
          trigger.setAttribute('data-bs-toggle', 'collapse');
          trigger.removeAttribute('data-hover-only');
        }
      }
    }
    document.addEventListener('DOMContentLoaded', initHoverCat);
    window.addEventListener('resize', initHoverCat);
  })();